const OPEN_DIALOG = 'OPEN_DIALOG';

function openDialog (payload) {
	return {
		type: OPEN_DIALOG,
		payload,
		id: `d${Math.random() * 100000}`,
	};
}

const CLOSE_DIALOG = 'CLOSE_DIALOG';

function closeDialog (id = '') {
	return {
		type: CLOSE_DIALOG,
		id,
	};
}

const CLOSE_ALL_DIALOGS = 'CLOSE_ALL_DIALOGS';

function closeAllDialogs () {
	return {
		type: CLOSE_ALL_DIALOGS,
	};
}

export default {
	OPEN_DIALOG,
	openDialog,

	CLOSE_DIALOG,
	closeDialog,

	CLOSE_ALL_DIALOGS,
	closeAllDialogs,
};
